import React from "react";

import styled from "styled-components";
import PlayerInfo from "../playerInfo/playerInfo";

import BacksideCard from './back.jpg';

const Card = styled.img`
    background-color: white;
    padding: 4px;
    margin-right: -50px;
    box-shadow: -1px 1px 25px -7px rgba(0,0,0,0.23);
    border-radius: 8px;
    height: 100px;
`;

const CardWrapper = styled.div`
    margin: 4px 54px 4px 4px;
`;

const Wrapper = styled.div`
    margin: 4px 54px 4px 4px;
`;

const OpponentCards = ({count, player}) => {

    return (
        <Wrapper>
            <CardWrapper>
                {[...Array(count)].map((e, i) => <Card key={i} draggable={false} src={BacksideCard}/>)}
            </CardWrapper>
            <PlayerInfo player={player} />
        </Wrapper>
    );
};

export default OpponentCards;